// Dependencias
import React, { Component } from 'react';
import appConfig from '../../../../App.config';

// Componentes
import TitleSection from '../../../../Components/Generic/TitleSection/Index';
import ListAccordion from '../../../../Components/ListAccordion/Index';
import Obligaciones from '../../../../Components/Finanzas/Obligaciones';
import TableEvaluaciones from '../../../../Components/Finanzas/Evaluaciones/Table';
import Timeline from '../../../../Components/Finanzas/Timeline';

// Hojas de Estilos
import './Index.scss';

class ListadoArchivosIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMenuItemIndex: 0,
    };
    this.accordionItemClick = this.accordionItemClick.bind(this);
  }

  accordionItemClick(e, selectedItemIndex) {
    this.setState({
      selectedMenuItemIndex: selectedItemIndex,
    });
  }

  render() {
    const { model, timeline } = this.props;
    const { selectedMenuItemIndex } = this.state;
    const sectionsItems = model.sections.map(item => ({
      text: item.title,
      data: (
        <div>
          <TableEvaluaciones items={item.files} />
        </div>
      ),
    }));

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <TitleSection text="CICLO PRESUPUESTARIO" />
            <Timeline items={timeline} activeIndex={model.timelineActiveItemIndex} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="title-container">
              <h3>
                <span className="Title--blue">{model.title}</span>
                <b> { model.subtitle ? ` - ${model.subtitle}` : '' } </b>
              </h3>
            </div>
          </div>
        </div>
        <div className="row">
          <ListAccordion items={sectionsItems} indexSelected={selectedMenuItemIndex} callBackClick={this.accordionItemClick} />
        </div>
        <Obligaciones />
      </div>
    );
  }
}

ListadoArchivosIndex.defaultProps = {
  timeline: [
    {
      text: 'Planeación', url: appConfig.rootPath + appConfig.finanzas.urlBase + appConfig.finanzas.sections.planeacion, primaryText: true, icon: 'fas fa-lightbulb', color: 'default', colorHover: 'green', iconVisible: false, textVisible: true,
    },
    {
      text: 'Programación', url: appConfig.rootPath + appConfig.finanzas.urlBase + appConfig.finanzas.sections.programacion, icon: 'fas fa-calendar-alt', color: 'default', colorHover: 'lemon', iconVisible: false, textVisible: true,
    },
    {
      text: 'Presupuestación', url: appConfig.rootPath + appConfig.finanzas.urlBase + appConfig.finanzas.sections.presupuesto, primaryText: true, icon: 'fas fa-dollar-sign', color: 'default', colorHover: 'blue', iconVisible: false, textVisible: true,
    },
    {
      text: 'Rendición de Cuentas', url: appConfig.rootPath + appConfig.finanzas.urlBase + appConfig.finanzas.sections.rendicionCuentas, icon: 'fas fa-file-alt', color: 'default', colorHover: 'yellow', iconVisible: false, textVisible: true,
    },
    {
      text: 'Evaluación', url: appConfig.rootPath + appConfig.finanzas.urlBase + appConfig.finanzas.sections.evaluacion, primaryText: true, icon: 'fas fa-calendar-check', color: 'default', colorHover: 'red', iconVisible: false, textVisible: true,
    },
    {
      text: 'Deuda', url: appConfig.rootPath + appConfig.finanzas.urlBase + appConfig.finanzas.sections.deuda, icon: 'fab fa-joomla', color: 'default', colorHover: 'purple', iconVisible: false, textVisible: true,
    },
    {
      text: 'Estadisticas', url: appConfig.rootPath + appConfig.finanzas.urlBase + appConfig.finanzas.sections.estadisticas, primaryText: true, icon: 'fas fa-chart-bar', color: 'default', colorHover: 'orange', iconVisible: false, textVisible: true,
    },
  ],
};

export default ListadoArchivosIndex;
